<template lang="pug">
section
  s-page-title(title='Я партнер')
  v-card
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Название') {{ props.item.name }}
          td(data-label='Сфера деятельности') {{ orgSphereName(props.item.sphere_id) }}
          td(data-label='Кол-во акций') {{ props.item.actions_count }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '60%',
        sortable: false
      },
      {
        text: 'Сфера деятельности',
        align: 'left',
        value: 'sphere_id',
        width: '20%',
        sortable: false
      },
      {
        text: 'Кол-во акций',
        align: 'left',
        value: 'actions_count',
        width: '40%',
        sortable: false
      }
    ]
  }),

  created() {
    this.fetch()
    this.fetchOrgSpheresDict()
  },

  methods: {
    onEdit(id) {
      this.$router.push({
        name: 'Partner.Organizations.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList()
    },

    orgSphereName(id) {
      let sphere = this.orgSphereById(id)
      return sphere ? sphere.name : null
    },

    ...mapActions('partner/organizations', ['fetchList']),
    ...mapActions('dictionary/orgSpheres', { fetchOrgSpheresDict: 'fetch' })
  },

  computed: {
    ...mapGetters('partner/organizations', ['list', 'isLoading']),
    ...mapGetters('dictionary/orgSpheres', { orgSphereById: 'byId' })
  }
}
</script>
